export default __webpack_public_path__ + "static/media/product-1.bcb70008.jpg";